/**
 * --------------------------------------------------------------------------
 * Custom Tooltips for Chart.js (v4.1.0): index.umd.js
 * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

import customTooltips from './src/custom-tooltips.js'

export default {
  customTooltips
}
